<div class="popover-content-wrapper" [class.editing]="isEditing()">
  <div class="popover-header">
    @if (isPinned()) {
      <dojo-icon-button [icon]="'xmark'" [size]="'xs'" (click)="onClose()" />
    }
  </div>

  <div class="popover-body">
    <dojo-tiptap-editor-wrapper
      class="popover-editor"
      [class.readonly]="!isEditing()"
      [valueControl]="editorControl"
      [editable]="isEditing()"
      [contentPadding]="'1em'"
    />

    @if (isEditing()) {
      <dojo-text-input
        [formCtrl]="linkUrlControl"
        [label]="'examdojo.popover.link_url_label' | transloco"
        [placeholder]="'examdojo.popover.link_url_placeholder' | transloco"
      />
    } @else if (linkUrl()) {
      <a [routerLink]="linkUrl()" (click)="onClose()">
        <dojo-button class="w-full">
          {{ 'examdojo.learn_more' | transloco }}
        </dojo-button>
      </a>
    }
  </div>
</div>
